module.exports = __webpack_public_path__ + "static/media/sun-cloud-rain.86e6f8e0.png";